import styled from 'styled-components'

export const ErrorParagraph = styled.p`
  color: red;
  margin: 1rem;
  font-size: 1rem;
`

export const InfoText = styled.div`
  font-size: 12px
`

export const Form = styled.form`
  div {
    margin-top: 0px;
  }
`
